import React, { useEffect, useState } from "react";
import { Content, Sidebar, Header } from "./index";
import { useDispatch, useSelector } from "react-redux";
import { GetCompanyList } from "../graphql/dashboard";
import {
  getUpdateCompanyNeeded,
  importCompanyList,
  importSelectedCompany,
} from "../redux/actions/companyList";
import { importUpdateNeeded } from "../redux/actions/flujocaja";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Grid } from 'semantic-ui-react'
import "./layout.scss";
import { CompanyContext, FlowContext, UserContext } from "src/context";
import { GetUserById } from "src/graphql/users";
import { GetFlowStructure } from "src/graphql/cashflow";

const Layout = (props) => {
  const dispatch = useDispatch()
  const matches = useMediaQuery("(max-width:992px)");
  const [showCompanyList, setShowCompanyList] = useState(false)
  const [hideCompanyList, setHideCompanyList] = useState(true)
  const [maximized, setMaximized] = useState(false)

  const userId = JSON.parse(localStorage.getItem("user"))

  const { fetching, data, reexecuteQuery, ...rest } = GetCompanyList()
  const { data: userInfo, executeQuery: refetchUserInfo } = GetUserById({ id: userId?.uid })
  
  const { updateNeeded } = useSelector((state) => state.flujocaja)
  const { selectedCompany, updateCompanyNeeded } = useSelector((state) => state.companyList)
  const { updateCashflowNeeded } = useSelector((state) => state.flujocaja)
  const { data: flowStructureData, reexecuteFlow, fetching: flowStructureFetching } = GetFlowStructure({ companyId:selectedCompany?.id })

  useEffect(() => {
    reexecuteFlow({ requestPolicy: 'network-only' })
  }, [selectedCompany?.id])

  useEffect(() => {
    if(updateCashflowNeeded?.value) reexecuteFlow({ requestPolicy: 'network-only' })
  }, [updateCashflowNeeded?.value])

  useEffect(() => {
    if (!fetching && data?.companiesByUser) {
      dispatch(importCompanyList(data.companiesByUser))
      if (!selectedCompany.id) return dispatch(importSelectedCompany(data.companiesByUser[0]))

      const currentCompany = data.companiesByUser.find((company) => company.id == selectedCompany.id)
      return dispatch(importSelectedCompany(currentCompany))
    }
  }, [fetching, data?.companiesByUser])

  useEffect(() => {
    if (updateNeeded.value) {
      reexecuteQuery({ requestPolicy: 'cache-and-network' })
      dispatch(importUpdateNeeded({ value: false }))
    }

    if (updateCompanyNeeded?.value) {
      reexecuteQuery({ requestPolicy: 'cache-and-network' })
      dispatch(getUpdateCompanyNeeded({ value: false }))
    }
  }, [updateNeeded?.value, updateCompanyNeeded?.value])

  useEffect(() => {
    reexecuteQuery({ requestPolicy: 'network-only' })
    refetchUserInfo({ requestPolicy: 'network-only' })
  }, [])

  const contextInformation = {
    companyList: data?.companiesByUser || [],
    selectedCompany,
  }

  return (
    <UserContext.Provider value={userInfo?.User || {}}>
    <CompanyContext.Provider value={contextInformation}>
    <FlowContext.Provider value={flowStructureData?.getFlowStructure ? flowStructureData?.getFlowStructure[0] || {} : {}}>
    <div
      className="c-app c-default-layout"
      style={{ backgroundColor: "#F3F4F6" }}
    >
      <Grid className="p-0 m-0">
        <Header location={props.location} />
      </Grid>
        <Sidebar
          showCompanyList={showCompanyList}
          setShowCompanyList={setShowCompanyList}
          hideCompanyList={hideCompanyList}
          setHideCompanyList={setHideCompanyList}
          maximized={maximized}
          setMaximized={setMaximized}
        />
      <div className="c-wrapper contentWidth ml-0">
        <div
          className="c-body contentML"
          style={{
            marginLeft: matches ? "0px" : "56px",
            transition: "0.5s",
            overflow: "hidden",
          }}
        >
          <Content
            maximized={maximized}
            setMaximized={setMaximized}
            showCompanyList={showCompanyList}
            setShowCompanyList={setShowCompanyList}
            hideCompanyList={hideCompanyList}
          />
        </div>
      </div>
    </div>
    </FlowContext.Provider>
    </CompanyContext.Provider>
    </UserContext.Provider>
  );
};

export default Layout;
